import { useContext } from 'react';
import AppDataContext from '../../context/AppDataContext';
import EyRnButton from '../EyRnButton/EyRnButton';
import styles from './Header.module.scss';
import { useNavigate } from 'react-router';
import { useLocation } from 'react-router-dom';

export default function Header() {
  const { isHeaderShow, headerData, isShowBackArrow }: any = useContext(AppDataContext);
  const history = useNavigate();
  const location = useLocation();
  
  const isHome = location.pathname.endsWith('/') || location.pathname.endsWith('home');
  return (
    <>
      {isHeaderShow && (
        <header className={styles.appHeader}>
          <div className={styles.titleWrapper}>
            {(isShowBackArrow && !isHome) && (<span className='icon-arrow-left' onClick={() => history(-1) }></span>)}
            <h2 className={styles.pageTitle}>{headerData?.title}</h2>
          </div>

          <EyRnButton />

        </header>
      )}
    </>

  )
}
